<template>
<div class="content">
	<div class="my-title">
		<Row :gutter="10">
			<Col :span="params.product=='companyGroupEmployer'?18:12">我的保障</Col>
			<Col span="6" v-if="params.product!='companyGroupEmployer'">
				<Select v-model="params.applicantInfo" placeholder="请选择服务商" clearable @on-change="getList()">
					<Option :value="item.bizCode" v-for="(item, index) in companyList" :key="index">{{item.name}}</Option>
				</Select>
			</Col>
			<Col span="6">
				<Select v-model="params.product" placeholder="请选择产品" @on-change="productChange">
					<Option value="companyGroupEmployer">企业团体雇主责任险</Option>
					<Option value="TRUCK_EMPLOYERS_LIABILITY_INSURANCE">货车雇主责任险</Option>
				</Select>
			</Col>
		</Row>
	</div>
	<Tabs v-model="status">
        <TabPane label="全部保障" name="ALL"></TabPane>
        <TabPane label="待生效" :name="params.product=='companyGroupEmployer'?'WAITING_EFFECT':'TO_BE_EFFECTIVE'"></TabPane>
        <TabPane label="保障中" :name="params.product=='companyGroupEmployer'?'TO_PROTECT':'EFFECTIVE'"></TabPane>
        <TabPane label="已失效" :name=" params.product=='companyGroupEmployer'?'LOST_EFFECT':'EXPIRED'"></TabPane>
    </Tabs>
	<Form :label-width="80" v-if="params.product=='companyGroupEmployer'">
		<Row>
			<Col span="8">
				<FormItem label="投保公司">
					<Input v-model="params.companyName" clearable placeholder="请输入投保公司" />
				</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="凭证号">
					<Input v-model="params.policyVoucherNo" clearable placeholder="请输入凭证号" />
				</FormItem>
			</Col>
			<Col span="6">
				&nbsp;<Button type="info" @click="search">搜索</Button>
			</Col>
		</Row>
	</Form>
    <div class="orders">
    	<PolicyItem v-for="(item,index) in list.data" :key="index" :info="item" />
    	<div class="nothing" v-if="list.data&&list.data.length==0">暂无数据</div>
    	<div class="page">
    		<Page 
    			:total="list.total" 
    			show-total
    			@on-change="getList" />
    	</div>
    </div>
</div>
</template>
<script>
import PolicyItem from '../common/PolicyItem'
import { mapState } from 'vuex'
export default {
	components:{ PolicyItem },
	data () {
		return {
			status:'ALL',
			list:{},
			params:{
				product:this.$route.query.product||'companyGroupEmployer'
			},
			companyList:[]
		}
	},
	watch:{
		status (v) {
			this.getList()
		},
		userInfo(v){
			this.checkLogin()
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		}),
	},
	created () {
		if(this.checkLogin()){
			this.getList();
			this.getCompanyList();
		}
	},
	methods:{
		search () {
			this.getList()
		},
		// 检测登录
		checkLogin(){
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 获取服务商列表
		getCompanyList(){
			this.$axios.get('/broker/enterprise/findHaveBind').then(res=>{
				this.companyList=res;
			}).catch(e=>{
				console.log(e)
			});
		},
		getList (page=1) {
			let form={};
			let url=''
			if(this.params.product=='companyGroupEmployer'){
				url='/employerLiability/getMyPolicy.all'
				form={
					page,
					count:10,
					statusType:this.status,
					companyName:this.params.companyName||'',
					policyVoucherNo:this.params.policyVoucherNo||''
				}
			}else{
				url='/broker/insurance/policy/list.json.all'
				form={
					page,
					count:10,
					effectiveStatus:this.status=='ALL'?'':this.status,
					bizId:this.params.product,
					applicantInfo:this.params.applicantInfo
				}
			}
			this.$axios.post(url,form).then(res=>{
				this.page=page;
				if(this.params.product!='companyGroupEmployer'){
					res.data=res.data.map(item => {
						return {
							...item,
							id:item.insurancePolicyId,
							insuranceCompanyName:item.companyName,
							companyName:item.applicantList&&item.applicantList.length>0?item.applicantList[0].subjectName:'',
							scheme:item.subjectMatter&&item.subjectMatter.length>0?item.subjectMatter[0].scheme:''
						}
					});
				}
				this.list = res
			})
			.catch(e=>{
				console.log(e)
			});
		},
		productChange(val){
			this.$router.replace({
				path:this.$route.path,
				query:{
					product:this.params.product
				}
			})
			this.getList()
		}
	}
}
</script>
<style scoped>
	.content{
		padding:0 15px 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/policy/index.vue